import React, { FC } from 'react'
import { MARKETING_APP_URL } from '@dashboard/lib/constants'

import css from './styles.module.scss'

interface OwnProps {
  showLogin?: boolean
}

const ComparisonNav: FC<OwnProps> = () => {
  return (
    <div className={css.container}>
      <div className={css.start}>
        <a href={MARKETING_APP_URL}>
          <img
            className={css.logo}
            src="/static/share/images/crystal_svg_text_logo.svg"
            alt="Crystal Logo"
          />
        </a>
      </div>
    </div>
  )
}

export default ComparisonNav
